import Page from '../page';
import { scrollToYOffset } from '../../helpers/scroll-to-helper';

import 'lightgallery.js';
import 'lightgallery.js/dist/css/lightgallery.css';

export default class GenericShow extends Page {
  constructor(...args) {
    super(...args);
    // Props
    this._isMobile = this._device === 'mobile';
    this._getDOM();
    this._bind();
  }

  _getDOM() {
    this.dom.commentsAnchor = this.dom.page.querySelector('#comments-anchor-js');
    this.dom.commentsTarget = this.dom.page.querySelector('#comments-section');
    // Check if mobile, detect specific element only present in mobile
    if (this.dom.page.querySelectorAll('.js-mobile-bottom-navigation').length > 0 && this._isMobile === true) {
      // DOM : mobile elements
      this.dom.mobile = {};
      this.dom.mobile.navigation = this.dom.page.querySelector('.js-mobile-bottom-navigation');
      this.dom.mobile.container = this.dom.page.querySelector('.js-mobile-show-options-container');
    }
  }

  _bind() {
    // initialize selection manager
    this.selectionManager.init();
    this._initCommentsExpander();
    this._initExpandableDescription();
    this._handleCommentsAnchorScroll();
    this._handleCommentsImageGalleries();
  }

  _initExpandableDescription() {
    const button = this.dom.page.querySelector('.expandable-description-trigger');
    if (!button) {
      return;
    }

    const wrapper = this.dom.page.querySelector(button.dataset.expands);
    if (!wrapper) {
      return;
    }

    const limit = 300;
    if (wrapper.clientHeight <= limit) {
      return;
    }

    const originalHeight = wrapper.clientHeight;
    wrapper.classList.add('collapsed');
    wrapper.classList.remove('fully-expanded');
    wrapper.style.height = limit + 'px';
    button.style.display = 'block';

    button.addEventListener('click', () => {
      wrapper.classList.toggle('collapsed');
      button.classList.toggle('collapsed');
      if (button.classList.contains('collapsed')) {
        wrapper.style.height = limit + 'px';
        button.innerHTML = 'En savoir plus';
      } else {
        wrapper.style.height = originalHeight + 'px';
        button.innerHTML = 'Masquer';
      }
    });
  }

  _initCommentsExpander() {
    const button = this.dom.page.querySelector('.js-show-more-comments');
    const wrapper = this.dom.page.querySelector('.js-more-comments');
    if (!button || !wrapper) {
      return;
    }
    button.addEventListener('click', () => {
      if (wrapper.classList.contains('show')) {
        return;
      }
      // visually hide trigger button
      button.style.visibility = 'hidden';
      // calculate future wrapper height
      const wrapperHeight = wrapper.scrollHeight;
      // handle sidebar "fixed" class toogle flicker
      if (!this.dom.sidebar.classList.contains('fixed')) {
        const bScreen = window.pageYOffset + window.innerHeight + wrapperHeight;
        if (bScreen > this.footerTop) {
          this.dom.sidebar.classList.add('fixed');
        }
      }
      // affect wrapper height and trigger transition
      wrapper.style.height = wrapperHeight + 'px';
      // call page.js resize method at the end of transition to update layout elements offsets
      wrapper.addEventListener('transitionend', () => {
        this.resize();
      });
    });
  }

  _handleCommentsAnchorScroll() {
    if (this.dom.commentsAnchor) {
      this.dom.commentsAnchor.addEventListener('click', (e) => {
        e.preventDefault();
        scrollToYOffset(this.dom.commentsTarget.offsetTop - 25);
      });
    }
  }

  _handleCommentsImageGalleries() {
    this.dom.page
      .querySelectorAll('#comments-section .images')
      .forEach((el) => {
        lightGallery(el);
      });
  }
}
